import { useState, useEffect, useRef } from 'react';

const CoursesHeader = () => {
  const [counts, setCounts] = useState({ courses: 0, capacity: 0, days: 0 });
  const [hasAnimated, setHasAnimated] = useState(false);
  const statsRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !hasAnimated) {
          setHasAnimated(true);
          
          // Count-up animasyonu
          const duration = 1500;
          const steps = 60;
          const stepDuration = duration / steps;
          
          const targets = { courses: 8, capacity: 20, days: 2 };
          let currentStep = 0;
          
          const timer = setInterval(() => {
            currentStep++;
            const progress = currentStep / steps;
            
            setCounts({
              courses: Math.round(targets.courses * progress),
              capacity: Math.round(targets.capacity * progress),
              days: Math.round(targets.days * progress),
            });
            
            if (currentStep >= steps) {
              clearInterval(timer);
              setCounts(targets);
            }
          }, stepDuration);
          
          return () => clearInterval(timer);
        }
      },
      { threshold: 0.3 }
    );

    if (statsRef.current) {
      observer.observe(statsRef.current);
    }

    return () => observer.disconnect();
  }, [hasAnimated]);

  return (
    <div className="relative bg-[#0D1B3E] pt-32 pb-20 overflow-hidden">
      <div className="absolute inset-0 bg-[url('https://public.readdy.ai/ai/img_res/0bae46df640338bf94aa83c286d0c84f.jpg')] bg-cover bg-center opacity-10"></div>
      <div className="absolute inset-0 bg-gradient-to-b from-[#0D1B3E]/80 via-[#0D1B3E]/70 to-[#0D1B3E]/90"></div>

      <div className="relative max-w-[1400px] mx-auto px-6">
        <div className="text-center">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#C9A84C]/20 border border-[#C9A84C]/40 rounded-full mb-6">
            <i className="ri-graduation-cap-line text-[#C9A84C] text-sm"></i>
            <span className="text-[#C9A84C] text-sm font-semibold tracking-wider uppercase">Uygulamalı Eğitim</span>
          </div>

          <h1 className="text-5xl font-bold text-white mb-4">
            Kurslar
          </h1>

          <p className="text-lg text-white/70 max-w-2xl mx-auto">
            3 Mayıs 2026 tarihlerinde İstanbul Atlas Üniversitesi Kongre Merkezi'nde düzenlenecek uygulamalı eğitim kursları
          </p>

          <div ref={statsRef} className="flex items-center justify-center gap-8 mt-10">
            <div className="text-center transform transition-all duration-500" style={{ opacity: hasAnimated ? 1 : 0, transform: hasAnimated ? 'translateY(0)' : 'translateY(20px)' }}>
              <div className="text-3xl font-bold text-[#C9A84C]">{counts.courses}</div>
              <div className="text-white/60 text-sm mt-1">Kurs</div>
            </div>
            <div className="w-px h-10 bg-white/20"></div>
            <div className="text-center transform transition-all duration-500" style={{ opacity: hasAnimated ? 1 : 0, transform: hasAnimated ? 'translateY(0)' : 'translateY(20px)', transitionDelay: '150ms' }}>
              <div className="text-3xl font-bold text-[#C9A84C]">{counts.capacity}</div>
              <div className="text-white/60 text-sm mt-1">Kişilik Kontenjan</div>
            </div>
            <div className="w-px h-10 bg-white/20"></div>
            <div className="text-center transform transition-all duration-500" style={{ opacity: hasAnimated ? 1 : 0, transform: hasAnimated ? 'translateY(0)' : 'translateY(20px)', transitionDelay: '300ms' }}>
              <div className="text-3xl font-bold text-[#C9A84C]">{counts.days}</div>
              <div className="text-white/60 text-sm mt-1">Gün</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CoursesHeader;